export default "/images/vendor/flag-icons/flags/4x3/se.svg?369f685ebb83712ce954eac60af580b7";